<template>
  <div :class="bem.b()">
    <div v-for="(menu, index) in menus" :key="index" :class="bem.e('menu')">
      <cms-cascader-node
        v-for="node in menu"
        :key="node.value"
        :node="node"
        :level="index"
        @expand="handleExpand"
        @check="handleCheck"
      ></cms-cascader-node>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'cms-cascader-panel',
  inheritAttrs: false
}
</script>

<script setup lang="ts">
import { ref, computed, watch } from 'vue'
import { createNamespace } from '@chenms-zj/utils/create'
import {
  cascaderProps,
  cascaderEmits,
  CascaderOption,
  CascaderValue
} from './cascaders'
import CmsCascaderNode from './cascader-nodes.vue'

const bem = createNamespace('cascader-panel')

const props = defineProps(cascaderProps)
const emit = defineEmits(cascaderEmits)

const menus = ref<CascaderOption[][]>([])
const activeValue = ref<(string | number)[]>([])

watch(() => props.options, initMenus, { immediate: true })

function initMenus() {
  menus.value = [props.options]
  activeValue.value = []
}

function handleExpand(node: CascaderOption, level: number) {
  if (node.children) {
    menus.value = menus.value.slice(0, level + 1)
    menus.value.push(node.children)
    activeValue.value = activeValue.value.slice(0, level + 1)
    activeValue.value.push(node.value)
    emit('expand-change', activeValue.value)
  }
}

function handleCheck(node: CascaderOption, level: number) {
  const newValue = activeValue.value.slice(0, level + 1)
  newValue[level] = node.value
  emit('update:modelValue', newValue)
  emit('change', newValue)
}

// 其他必要的方法和计算属性
</script>

<style scoped>
/* 组件样式可以在这里添加，或者在全局样式文件中定义 */
</style>
